// The Privacy Notice text, bundled at build time from privacy.md (wording owned by
// the owner and the attorney: never edit it here). PRIVACY_VERSION comes from its
// "Version" line, parsed the same way as the Terms of Use.
import md from '../content/privacy.md';
import { parseTermsVersion } from './terms';

export const PRIVACY_MD: string = md;
export const PRIVACY_VERSION: string = parseTermsVersion(md);
if (!PRIVACY_VERSION) throw new Error('src/content/privacy.md needs a "Version <id>" line');
